import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import Component from 'components/Count/ClearItems'

const mapStateToProps = (state, props) => ({ ...createAuthStateToProps(state, props) })

export default connect(mapStateToProps, null)(Component)
